/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Already_LinkedInputs */

const en_auth_error_already_linked = /** @type {(inputs: Auth_Error_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That account is already connected to a different Listening account. Sign in with that one, or use your email address instead.`)
};

const es_auth_error_already_linked = /** @type {(inputs: Auth_Error_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa cuenta ya está conectada a otra cuenta de Listening. Inicia sesión con esa, o usa tu correo electrónico.`)
};

/**
* | output |
* | --- |
* | "That account is already connected to a different Listening account. Sign in with that one, or use your email address instead." |
*
* @param {Auth_Error_Already_LinkedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_already_linked = /** @type {((inputs?: Auth_Error_Already_LinkedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Already_LinkedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_already_linked(inputs)
	return en_auth_error_already_linked(inputs)
});